const damageStatuses = [
  // Status de Danos Físicos
  { label: 'Riscada', value: 'scratched' },
  { label: 'Quebrada', value: 'broken' },
  { label: 'Amassada', value: 'dented' },
  { label: 'Trincada', value: 'cracked' },
  { label: 'Furada', value: 'punctured' },
  { label: 'Desgastada', value: 'worn' },
  { label: 'Enferrujada', value: 'rusty' },
  { label: 'Descascada', value: 'chipped' },
  { label: 'Desalinhada', value: 'misaligned' },
  { label: 'Manchada', value: 'stained' },

  // Status de Pintura
  { label: 'Desbotada', value: 'faded' },
  { label: 'Com Bolhas', value: 'bubbled' },
  { label: 'Arranhada', value: 'scratched_paint' },
  { label: 'Descascada', value: 'peeling' },
  { label: 'Com Mancha de Tinta', value: 'paint_stained' },
  { label: 'Com Diferença de Cor', value: 'color_mismatch' },

  // Outros Status Úteis
  { label: 'Faltando Peça', value: 'missing_part' },
  { label: 'Com Ferrugem Superficial', value: 'surface_rust' },
  { label: 'Com Dano Estrutural', value: 'structural_damage' },
  { label: 'Falha', value: 'failure' },
  { label: 'Sinal de avariamento', value: 'sign_of_damage' },
];

export { damageStatuses };
